/**
 * Контракт «состояние экрана» для снимков Стола (Этап 3, заход 1).
 *
 * Экран паспортизируется, регистрируя провайдера: раздел на маунте вешает
 * функцию, отдающую структурированное состояние (экран/режим, окно, фильтры,
 * видимые метрики). В заходе 1 паспорт полон на Компасе (/ads); экраны без
 * провайдера шлют базовый снимок с пометкой «раздел не паспортизирован».
 */

export interface ScreenPassport {
  /** Человеческое имя раздела, напр. «Реклама · Компас». */
  section: string;
  /** Структурированное состояние: режим, окно 3/7/14/30, фильтры, метрики. */
  state: Record<string, unknown>;
}

type PassportProvider = () => ScreenPassport | null;

let provider: PassportProvider | null = null;

/** Регистрирует провайдера паспорта; вернувшийся колбэк снимает его на анмаунте. */
export function registerPassportProvider(fn: PassportProvider): () => void {
  provider = fn;
  return () => {
    if (provider === fn) {
      provider = null;
    }
  };
}

/** Паспорт текущего экрана либо null — «раздел не паспортизирован». */
export function collectPassport(): ScreenPassport | null {
  try {
    return provider?.() ?? null;
  } catch {
    // Кривой провайдер не должен ломать базовый снимок.
    return null;
  }
}
